import Type from "./Type";

const TaxFile = {
  Type,
};

export default TaxFile;
